import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { putExecution } from '../Api'

export default generateApiAction({
  baseType: Types.EXECUTIONS.PUT,
  api: putExecution,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/executions/PutAction.js